'use client';

import React from 'react';
import { CustomButton } from '@/components/ui/CustomButton';
import { AnnualRepaymentTabs } from '../AnnualRepaymentTabs';

export const CalculatorResults = ({ formData, setCurrentTabId, showResults }) => {
  if (!showResults) return null;

  return (
    <>
      <div id="chart-container pt-32">
        <AnnualRepaymentTabs
          formData={{
            dataRemainingBalanceTable: formData.dataRemainingBalanceTable,
            equityRemainingGraphDataWithoutPayment: formData.equityRemainingGraphDataWithoutPayment,
            equityRemainingGraphDataWithPayment: formData.equityRemainingGraphDataWithPayment,
            loanBalanceGraphDataWithOutPayment: formData.loanBalanceGraphDataWithOutPayment,
            loanBalanceGraphDataWithPayment: formData.loanBalanceGraphDataWithPayment,
          }}
          setActiveTab={(tabId) => {setCurrentTabId(tabId);}}
        />
      </div>

      <CustomButton
        onClick={() => window.print()}
        className="w-full md:w-auto print-button mt-8 mb-8"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          className="mr-2"
          aria-hidden="true"
        >
          <path
            opacity="0.12"
            d="M2.25 15.75H15.75V11.25H2.25V15.75Z"
            fill="black"
          />
          <path
            d="M15.75 11.25V12.15C15.75 13.4101 15.75 14.0402 15.5048 14.5215C15.289 14.9448 14.9448 15.289 14.5215 15.5048C14.0402 15.75 13.4101 15.75 12.15 15.75H5.85C4.58988 15.75 3.95982 15.75 3.47852 15.5048C3.05516 15.289 2.71095 14.9448 2.49524 14.5215C2.25 14.0402 2.25 13.4101 2.25 12.15V11.25M12.75 7.5L9 11.25M9 11.25L5.25 7.5M9 11.25V2.25"
            stroke="#F3F4F8"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        Save/Print Results
      </CustomButton>
    </>
  );
};
